module.exports = __webpack_public_path__ + "static/media/logo.c6f11019.svg";